<template>
  <!-- logo -->
  <div
    class="opacity-80 icon-container"
    :class="{
      'force-light': theme === 'light',
      'force-dark': theme === 'dark',
    }"
    :style="style"
  >
    <svg
      height="100%"
      viewBox="0 0 200 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_108_62)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.06787 2.63152C5.06787 1.80291 5.84657 1.19499 6.65029 1.39614L26.2805 6.30914C26.8472 6.45097 27.2447 6.96028 27.2447 7.54452V38.8516C27.2447 39.4663 26.8056 39.9933 26.201 40.1042L6.57083 43.7041C5.78867 43.8475 5.06787 43.2468 5.06787 42.4515V2.63152Z"
          fill="#C7D2FE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.1257 2.63152C10.1257 1.80291 10.9044 1.19499 11.7082 1.39614L31.3383 6.30914C31.905 6.45097 32.3025 6.96028 32.3025 7.54452V38.8516C32.3025 39.4663 31.8635 39.9933 31.2589 40.1042L11.6287 43.7041C10.8465 43.8475 10.1257 43.2468 10.1257 42.4515V2.63152Z"
          fill="#818CF8"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.4666 2.63152C15.4666 1.80291 16.2453 1.19499 17.049 1.39614L36.6792 6.30914C37.2459 6.45097 37.6434 6.96028 37.6434 7.54452V38.8516C37.6434 39.4663 37.2043 39.9933 36.5997 40.1042L16.9695 43.7041C16.1874 43.8475 15.4666 43.2468 15.4666 42.4515V2.63152Z"
          fill="#1E40AF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.06787 2.63152C5.06787 1.80291 5.84657 1.19499 6.65029 1.39614L26.2805 6.30914C26.8472 6.45098 27.2447 6.96028 27.2447 7.54452V38.8516C27.2447 39.4663 26.8056 39.9933 26.201 40.1042L6.57083 43.7041C5.78867 43.8475 5.06787 43.2468 5.06787 42.4515V2.63152Z"
          fill="#C7D2FE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.1257 2.63152C10.1257 1.80291 10.9044 1.19499 11.7082 1.39614L31.3383 6.30914C31.905 6.45098 32.3025 6.96028 32.3025 7.54452V38.8516C32.3025 39.4663 31.8635 39.9933 31.2589 40.1042L11.6287 43.7041C10.8465 43.8475 10.1257 43.2468 10.1257 42.4515V2.63152Z"
          fill="#818CF8"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.4666 2.63152C15.4666 1.80291 16.2453 1.19499 17.049 1.39614L36.6792 6.30914C37.2459 6.45098 37.6434 6.96028 37.6434 7.54452V38.8516C37.6434 39.4663 37.2043 39.9933 36.5997 40.1042L16.9695 43.7041C16.1874 43.8475 15.4666 43.2468 15.4666 42.4515V2.63152Z"
          fill="#1E40AF"
        />
      </g>
      <path
        d="M67.9187 23.2642C67.9187 26.935 67.0875 29.8702 65.425 32.0698C63.7771 34.2548 61.5458 35.3473 58.7312 35.3473C56.5583 35.3473 54.7719 34.5534 53.3719 32.9657V42.6724L46 44V11.2685H52.8906L53.1094 13.4535C54.524 11.7055 56.3833 10.8314 58.6875 10.8314C61.6042 10.8314 63.8719 11.9094 65.4906 14.0653C67.1094 16.2066 67.9187 19.1564 67.9187 22.9146V23.2642ZM60.5469 22.8053C60.5469 18.6101 59.3219 16.5125 56.8719 16.5125C55.1219 16.5125 53.9552 17.1389 53.3719 18.3916V27.6998C54.0135 29.0108 55.1948 29.6663 56.9156 29.6663C59.2635 29.6663 60.474 27.6415 60.5469 23.5919V22.8053Z"
        fill="black"
      />
      <path
        d="M84.5219 34.9103C84.2594 34.4296 84.026 33.7231 83.8219 32.7909C82.4656 34.4952 80.5698 35.3473 78.1344 35.3473C75.9031 35.3473 74.0073 34.6773 72.4469 33.3371C70.8865 31.9824 70.1062 30.2854 70.1062 28.246C70.1062 25.6823 71.0542 23.7449 72.95 22.4339C74.8458 21.1229 77.6021 20.4674 81.2187 20.4674H83.4937V19.2219C83.4937 17.0515 82.5531 15.9662 80.6719 15.9662C78.9219 15.9662 78.0469 16.8257 78.0469 18.5446H70.675C70.675 16.2576 71.6448 14.4003 73.5844 12.9728C75.5385 11.5452 78.025 10.8314 81.0438 10.8314C84.0625 10.8314 86.4469 11.5671 88.1969 13.0383C89.9469 14.5096 90.8437 16.5271 90.8875 19.0908V29.557C90.9167 31.7275 91.2521 33.3881 91.8937 34.5389V34.9103H84.5219ZM79.9062 30.1033C80.825 30.1033 81.5833 29.9066 82.1812 29.5133C82.7937 29.12 83.2312 28.6757 83.4937 28.1805V24.4004H81.35C78.7833 24.4004 77.5 25.5512 77.5 27.8527C77.5 28.5228 77.726 29.0691 78.1781 29.4915C78.6302 29.8994 79.2062 30.1033 79.9062 30.1033Z"
        fill="black"
      />
      <path
        d="M104.997 29.6663C106.032 29.6663 106.834 29.3895 107.403 28.836C107.972 28.2679 108.249 27.4813 108.234 26.4762H115.147C115.147 29.0691 114.214 31.1958 112.347 32.8564C110.495 34.517 108.103 35.3473 105.172 35.3473C101.73 35.3473 99.0177 34.2694 97.0344 32.1135C95.051 29.9576 94.0594 26.9714 94.0594 23.1549V22.849C94.0594 20.4601 94.4969 18.3552 95.3719 16.5343C96.2615 14.6989 97.5375 13.2932 99.2 12.3173C100.862 11.3267 102.831 10.8314 105.106 10.8314C108.183 10.8314 110.626 11.6836 112.434 13.3879C114.243 15.0922 115.147 17.4011 115.147 20.3144H108.234C108.234 19.0908 107.935 18.1513 107.337 17.4957C106.74 16.8402 105.937 16.5125 104.931 16.5125C103.021 16.5125 101.905 17.7288 101.584 20.1615C101.482 20.9335 101.431 21.9969 101.431 23.3516C101.431 25.726 101.716 27.372 102.284 28.2897C102.853 29.2074 103.757 29.6663 104.997 29.6663Z"
        fill="black"
      />
      <path
        d="M130.656 28.2679C130.656 27.6415 130.328 27.139 129.672 26.7602C129.016 26.3815 127.769 25.9882 125.931 25.5803C124.094 25.1724 122.577 24.6408 121.381 23.9853C120.185 23.3152 119.274 22.5067 118.647 21.5599C118.02 20.613 117.706 19.5278 117.706 18.3042C117.706 16.1338 118.603 14.3493 120.397 12.9509C122.191 11.5379 124.539 10.8314 127.441 10.8314C130.561 10.8314 133.07 11.5379 134.966 12.9509C136.861 14.3639 137.809 16.2212 137.809 18.5227H130.416C130.416 16.629 129.417 15.6822 127.419 15.6822C126.646 15.6822 125.997 15.9007 125.472 16.3377C124.947 16.7601 124.684 17.2918 124.684 17.9328C124.684 18.5883 125.005 19.1199 125.647 19.5278C126.289 19.9357 127.309 20.2707 128.709 20.5329C130.124 20.7951 131.364 21.1083 132.428 21.4725C135.986 22.6961 137.766 24.8884 137.766 28.0494C137.766 30.2053 136.803 31.9606 134.878 33.3153C132.968 34.67 130.489 35.3473 127.441 35.3473C125.414 35.3473 123.605 34.9832 122.016 34.2548C120.426 33.5265 119.186 32.5359 118.297 31.2832C117.407 30.0305 116.962 28.7122 116.962 27.3283H123.853C123.882 28.4208 124.247 29.222 124.947 29.7318C125.647 30.2271 126.544 30.4747 127.637 30.4747C128.644 30.4747 129.395 30.2708 129.891 29.8629C130.401 29.4551 130.656 28.9234 130.656 28.2679Z"
        fill="black"
      />
      <path
        d="M163.206 23.286C163.206 27.1608 162.404 30.1397 160.8 32.2228C159.196 34.3058 156.935 35.3473 154.019 35.3473C151.612 35.3473 149.673 34.3932 148.2 32.485L147.894 34.9103H141.287V1.34848L148.659 0V13.1694C150.03 11.6108 151.802 10.8314 153.975 10.8314C156.921 10.8314 159.196 11.8875 160.8 13.9997C162.404 16.1119 163.206 19.0835 163.206 22.9146V23.286ZM155.812 22.8272C155.812 20.5548 155.506 18.9379 154.894 17.9765C154.296 17.0005 153.37 16.5125 152.116 16.5125C150.453 16.5125 149.301 17.1461 148.659 18.4135V27.809C149.286 29.0618 150.453 29.6881 152.159 29.6881C153.895 29.6881 154.996 28.8433 155.462 27.1535C155.696 26.3232 155.812 24.8811 155.812 22.8272Z"
        fill="black"
      />
      <path
        d="M174.253 34.9103H166.859V11.2685H174.253V34.9103Z"
        fill="black"
      />
      <path
        d="M185.584 11.2685L185.825 14.0434C187.458 11.9021 189.711 10.8314 192.584 10.8314C195.049 10.8314 196.886 11.5671 198.097 13.0383C199.322 14.5096 199.956 16.7237 200 19.6808V34.9103H192.606V19.9867C192.606 18.7922 192.366 17.9182 191.884 17.3646C191.403 16.7965 190.528 16.5125 189.259 16.5125C187.816 16.5125 186.744 17.0806 186.044 18.2168V34.9103H178.672V11.2685H185.584Z"
        fill="black"
      />
      <path
        d="M173.16 2.41202C172.432 1.69841 171.493 1.3416 170.344 1.3416C169.182 1.3416 168.229 1.69841 167.487 2.41202C166.758 3.12563 166.394 4.01415 166.394 5.07757C166.394 6.14099 166.758 7.03651 167.487 7.76411C168.229 8.47773 169.182 8.83453 170.344 8.83453C171.493 8.83453 172.432 8.47773 173.16 7.76411C173.889 7.03651 174.253 6.14099 174.253 5.07757C174.253 4.01415 173.889 3.12563 173.16 2.41202Z"
        fill="black"
      />
      <defs>
        <clipPath id="clip0_108_62">
          <rect
            width="32.2572"
            height="42.9796"
            fill="white"
            transform="translate(5.38623 1)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
  <!-- / logo -->
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{ height?: string; theme?: string }>();
const style = computed(() => {
  return {
    height: props.height,
  };
});
</script>

<style scoped>
[data-theme="dark"] .icon-container {
  filter: invert(1) grayscale(1);
}
.icon-container.force-light {
  filter: invert(0) grayscale(0);
}
.icon-container.force-dark {
  filter: invert(1) grayscale(1);
}
</style>
